import React from "react";
import Styles from './styles.module.scss'
import Seo from "../../components/_UI/seo";
import ApplyFormS1 from "../../components/applyFormS1";
import ApplyForm from "../../components/applyForm";


const ApplyFormPage = () => {
    return (
        <section className={`${Styles.container}`}>
            <Seo title="Form"/>
            <div className={`${Styles.contentWrap}`}>
                <ApplyFormS1/>
                <ApplyForm/>
            </div>
        </section>
    );
};

export default ApplyFormPage;
